// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import {
  mdiAccountCardOutline,
  mdiAccountCreditCard,
  mdiAccountCreditCardOutline,
  mdiAccountDetailsOutline,
  mdiAccountGroup,
  mdiAccountMultipleOutline,
  mdiAccountOutline,
  mdiAccountSchoolOutline,
  mdiAirplaneAlert,
  mdiAirplaneClock,
  mdiAirplanePlus,
  mdiAirplaneSearch,
  mdiAirplaneSettings,
  mdiAirplaneTakeoff,
  mdiAirport,
  mdiBankCircle,
  mdiBankTransfer,
  mdiBankTransferIn,
  mdiBookEducationOutline,
  mdiBookOpenPageVariantOutline,
  mdiBookshelf,
  mdiBriefcaseArrowLeftRight,
  mdiBriefcaseArrowLeftRightOutline,
  mdiCalculator,
  mdiCalendarAccount,
  mdiCalendarBadge,
  mdiCalendarCursor,
  mdiCalendarMonth,
  mdiCalendarMonthOutline,
  mdiCalendarMultiselect,
  mdiCalendarRemoveOutline,
  mdiCalendarToday,
  mdiCarCoolantLevel,
  mdiCardAccountDetailsOutline,
  mdiCardBulletedSettingsOutline,
  mdiCardSearchOutline,
  mdiCashClock,
  mdiCashRegister,
  mdiCashSync,
  mdiCctv,
  mdiChartBoxMultipleOutline,
  mdiChartDonut,
  mdiClipboardClockOutline,
  mdiClipboardList,
  mdiClipboardTextClockOutline,
  mdiClockAlertOutline,
  mdiCloudDownloadOutline,
  mdiCoffeeToGo,
  mdiContentDuplicate,
  mdiCreditCardRefund,
  mdiDatabaseExportOutline,
  mdiDatabaseSyncOutline,
  mdiDeleteOutline,
  mdiDiamondStone,
  mdiEmailFastOutline,
  mdiEmailPlusOutline,
  mdiFinance,
  mdiFloorPlan,
  mdiFolderArrowLeftRightOutline,
  mdiFoodForkDrink,
  mdiFoodOutline,
  mdiFormatListBulleted,
  mdiFormatListChecks,
  mdiFormatListText,
  mdiGasStation,
  mdiGasStationOutline,
  mdiGroup,
  mdiHandshakeOutline,
  mdiHumanMaleBoard,
  mdiHumanMaleBoardPoll,
  mdiHydraulicOilLevel,
  mdiInvoiceTextArrowRight,
  mdiInvoiceTextEditOutline,
  mdiLightbulbOutline,
  mdiListBoxOutline,
  mdiLockOpenAlert,
  mdiMapLegend,
  mdiMedalOutline,
  mdiNewspaper,
  mdiNewspaperPlus,
  mdiNewspaperVariantMultipleOutline,
  mdiNotebookMultiple,
  mdiNumeric9PlusBoxMultipleOutline,
  mdiPercentBox,
  mdiPirate,
  mdiProgressCheck,
  mdiReceiptText,
  mdiReceiptTextOutline,
  mdiRemoteDesktop,
  mdiReplyOutline,
  mdiRoutes,
  mdiScale,
  mdiScaleBalance,
  mdiSeatPassenger,
  mdiShapeOutline,
  mdiShieldAccountVariantOutline,
  mdiShieldAirplaneOutline,
  mdiShieldOutline,
  mdiShieldPlusOutline,
  mdiShieldSyncOutline,
  mdiSignatureFreehand,
  mdiSkullScanOutline,
  mdiSquareEditOutline,
  mdiStackOverflow,
  mdiSwapHorizontalCircleOutline,
  mdiSwapHorizontalHidden,
  mdiSwapHorizontalVariant,
  mdiSwapVerticalVariant,
  mdiTableChair,
  mdiTankerTruck,
  mdiTapeMeasure,
  mdiTextAccount,
  mdiTicketConfirmationOutline,
  mdiTicketOutline,
  mdiTimerSandComplete,
  mdiTools,
  mdiTooltipPlusOutline,
  mdiTowTruck,
  mdiTrafficLight,
  mdiTransfer,
  mdiTrayFull,
  mdiUndoVariant,
  mdiViewGridOutline,
  mdiViewGridPlusOutline,
  mdiViewList,
  mdiWalletOutline
} from "@mdi/js"; // or wherever your icons are coming from

// centralized mapping
export const iconMap: Record<string, string> = {
  mdiViewGridOutline,
  mdiCloudDownloadOutline,
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiClipboardClockOutline,
  mdiTimerSandComplete,
  mdiCalculator,
  mdiBankTransferIn,
  mdiTrafficLight,
  mdiRoutes,
  mdiReceiptTextOutline,
  mdiScaleBalance,
  mdiAirplaneAlert,
  mdiHydraulicOilLevel,
  mdiScale,
  mdiTapeMeasure,
  mdiSkullScanOutline,
  mdiAccountDetailsOutline,
  mdiCashClock,
  mdiAccountCreditCardOutline,
  mdiBankTransfer,
  mdiSwapHorizontalVariant,
  mdiCarCoolantLevel,
  mdiCashSync,
  mdiGasStation,
  mdiCalendarToday,
  mdiCalendarMonth,
  mdiAccountSchoolOutline,
  mdiCalendarRemoveOutline,
  mdiFoodForkDrink,
  mdiHumanMaleBoard,
  mdiClockAlertOutline,
  mdiClipboardList,
  mdiDatabaseExportOutline,
  mdiSwapHorizontalCircleOutline,
  mdiTransfer,
  mdiTextAccount,
  mdiBriefcaseArrowLeftRightOutline,
  mdiUndoVariant,
  mdiNumeric9PlusBoxMultipleOutline,
  mdiDatabaseSyncOutline,
  mdiGasStationOutline,
  mdiFormatListText,
  mdiInvoiceTextEditOutline,
  mdiTowTruck,
  mdiTankerTruck,
  mdiCalendarAccount,
  mdiPirate,
  mdiAccountGroup,
  mdiBankCircle,
  mdiBriefcaseArrowLeftRight,
  mdiReceiptText,
  mdiStackOverflow,
  mdiCalendarMultiselect,
  mdiAirplaneTakeoff,
  mdiTooltipPlusOutline,
  mdiReplyOutline,
  mdiListBoxOutline,
  mdiCashRegister,
  mdiShieldAirplaneOutline,
  mdiGroup,
  mdiCalendarMonthOutline,
  mdiTools,
  mdiSeatPassenger,
  mdiTrayFull,
  mdiEmailPlusOutline,
  mdiAirplanePlus,
  mdiInvoiceTextArrowRight,
  mdiPercentBox,
  mdiFinance,
  mdiCalendarBadge,
  mdiLockOpenAlert,
  mdiCardSearchOutline,
  mdiBookshelf,
  mdiViewList,
  mdiFormatListBulleted,
  mdiAirplaneSettings,
  mdiCalendarCursor,
  mdiSwapVerticalVariant,
  mdiAirplaneSearch,
  mdiHumanMaleBoardPoll,
  mdiTicketOutline,
  mdiTicketConfirmationOutline,
  mdiCoffeeToGo,
  mdiAccountCreditCard,
  mdiCreditCardRefund,
  mdiBookOpenPageVariantOutline,
  mdiChartDonut,
  mdiAirplaneClock,
  mdiAirport,
  mdiTableChair,
  mdiFoodOutline,
  mdiRemoteDesktop,
  mdiSignatureFreehand,
  mdiHandshakeOutline,
  mdiMedalOutline,
  mdiContentDuplicate,
  mdiDiamondStone,
  mdiCardBulletedSettingsOutline,
  mdiWalletOutline,
  mdiLightbulbOutline,
  mdiShieldAccountVariantOutline,
  mdiShieldPlusOutline,
  mdiShieldSyncOutline,
  mdiProgressCheck,
  mdiAccountCardOutline,
  mdiFolderArrowLeftRightOutline,
  mdiBookEducationOutline,
  mdiShieldOutline,
  mdiCardAccountDetailsOutline,
  mdiNotebookMultiple,
  mdiChartBoxMultipleOutline,
  mdiEmailFastOutline,
  mdiNewspaperVariantMultipleOutline,
  mdiNewspaper,
  mdiMapLegend,
  mdiCctv,
  mdiAccountMultipleOutline,
  mdiViewGridPlusOutline,
  mdiFloorPlan,
  mdiSquareEditOutline,
  mdiNewspaperPlus,
  mdiShapeOutline,
  mdiSwapHorizontalHidden,
  mdiFormatListChecks,
  mdiClipboardTextClockOutline,
};


export interface MenuItem {
  text: string;
  idMenu: number;
  isFavorite: number;
  isSideMenu: number;
  type?: string;
  href?: string;
  section?: string;
  items?: MenuItem[];
  badge?: boolean;
  badgeVariable?: string;
  badgeColor?: string;
  title?: string;
  description?: string;
  icon?: string;
  id?: string;
  isHidden?: number;
}

export type ItemAccountPlan = {
  idAccountPlan: number;
  accountPlan: string;
  value: string;
  label: string;
};

export type ItemGroupType = {
  idGroupType: number;
  bookingDeleteTime: number;
  bookAheadTime: number;
  bookingMaxGroup: number;
  maxBookingTime: number;
  minBookHour: number;
  maxBookHour: number;
  showOnBooking: number;
  idBookingTypes: number[];
  showOnFlightLog: number;
  jsonConfigEquipment: any;
  groupType: string;
  groupTypeMaster: string;
  groupTypeMasterCode: string;
  value: string;
  label: string;
};

export type ItemFilter = {
  idUserTypes?: number[];
  idCharges?: number[];
  idBookingTypes?: number[],
  idGroupTypes?: number[],
  idCategories?: number[],
  idAccountPlans?: number[],
  idChecks?: number[],
  statusesRequest?: number[],
  idGroups?: number[],
  idUserStatuses?: number[],
  keyw?: string[];
  operator?: string;
  intersection?: number;
  isActiveUser?: number;
  isDeleteUser?: number;
};

export type ItemUserType = {
  idUserType: number;
  userType: string;
  value: string;
  label: string;
};
export type ItemUserStatus = {
  idUserStatus: number;
  userStatus: string;
  value: string;
  label: string;
};
export type ItemCharges = {
  idCharge: number,
  ammount: number,
  currency: string,
  charge: string,
  accountPlan: string,
  label: string,
  value: string,
};
export type ItemsGroups = {
  idGroup: number,
  group: string,
  groupCode: string,
  dateGroup?: string,
  label: string,
  value: string,
};
export type ItemUser = {
  idUser: number,
  isActiveUser: number,

  isDeleteUser: number,
  canConcileBank: number,
  membership: number,
  balance: number,
  balance45: number,
  rutTransfer: string[],
  fineExclude: number,
  bookingUnlimited: number,
  displayName: string,
  initials: string,
  dateLastUpdatedInfo?: string,
  RUT: string,
  email: string,
  email2: string,
  phone: string,
  status: string,
  name: string,
  lastName: string,
  phone1: string,
  phone2: string,
  ICEPhone: string,
  ICEContact: string,
  dateBirth: string,
  dateMember: string,
  dateLastLogin?: string,
  age: number,
  needsInfoUpdate: boolean,
  metaData: {
    charges: ItemCharges[],
    groups: ItemsGroups[],

  }
  checks?: ItemCheck[]
  charges?: any[],
  balances?: any[],
  dailyBalances?: any[],
  movements: ItemsMovement[],
  groups: ItemsGroups[],
  bookings: ItemBooking[],
  idUserType: number;
  idUserStatus: number;
  userTypeUT: string;
  userTypeColor: string;

  userType: string,
  userStatus: string,
  value: string,
  label: string,
  description: string,

  groupCodes: string[],

  jsonFavorites: any;
  jsonLicences: any;
  jsonLicencesUpdated: string;
  jsonFintoc: any;
  studentCertification?: string;
  idCountry?: number;

};

// --- CORE TYPES ---
export type ItemCountry = {
  idCountry: number;
  country: string;
  ISO2: string;
  ISO3: string;
  value: string; // Cloudscape value (idGroupType.toString())
  label: string; // Cloudscape label (groupType)
};

export type ItemNote = {
  idMaintenance: number;
  idEquipment: number;
  note: string;
  answer: string;
  isOutOfFlight: number;
  idUser: number;
  statusMant: number,
  dateSubmited: string,
  dateNote: string,
  displayName: string,
  initials?: string,
  registration: string,
  imageCount: number;
  logCount: number;
  logs: any[];
  jsonLogs: any[];
  images: any[];
  jsonImages: any[];
  idUserRead: number[];
  dateClosed: string;
  keyw?: string;
  equipment?: any;
};

export type ItemsMovement = {
  idMovement: number,
  idCharge?: number,
  idUser?: number,
  idAccountPlan?: number,
  idFlight?: number,
  movement: number,
  accountPlan: string,
  dateTransaction: string,
  data: string,
  obs?: string,
  displayName: string,
  registration?: string,
  RUT: string,
  receipt?: string,
  ammount: number,
  balance: number,
  voucherStage?: number,
  jsonTBK: any;
  jsonMovement: any;
  jsonSII: any;
  jsonBank: any;
  jsonDocuments: any;
  idEquipment?: number;
  tbkCodAuto?: string;
  notify: boolean;
  transferCPS?: Number;
  transferCPV?: Number;
};
export interface BehaviorResource {
  precedence: string;
  pathPattern: string;
  origin: string;
  viewerProtocolPolicy: string;
  forwardedQueryStrings: string;
}

export interface LogResource {
  id: string;
  name: string;
  lastWritten: string;
  size: string;
}

export interface ContentOriginsResource {
  value: string;
  label: string;
}

export interface OriginResource {
  id: string;
  name: string;
  type: string;
  accessIdentity: string;
}
export interface InvalidationResource {
  id: string;
  status: string;
  date: string;
}

export interface DistributionResource {
  id: string;
  deliveryMethod: string;
  domainName: string;
  origin: string;
  priceClass: string;
  logging: string;
  sslCertificate: string;
  tags: { department: string[]; environment: string[] };
  date: Date;
  state?: 'Activated' | 'Deactivated';
}

export interface Tag {
  key: string;
  value: string;
}

export interface TagsResource {
  resourceTags: Tag[];
  valueMap: {
    owner: string[];
    project: string[];
    role: string[];
    performance: string[];
    profile: string[];
  };
}

export interface EC2Instance {
  id: string;
  type: string;
  publicDns: string;
  monitoring: string;
  state: string;
  platformDetails: string;
  terminalProtection: string;
  launchTime: string;
  volume: number;
  securityGroups: string[];
  loadBalancers: string[];
  availabilityZone: string;
  numOfvCpu: number;
  inboundRules: {
    type: string;
    protocol: string;
    portRange: string;
    source: string;
    description: string;
  }[];
}


export type ItemCheckParameter = {
  idCheckParameter: number;
  checkEval: string;
  jsonEval: { value: string; text: string; color: string }[];
};

export type ItemnCheckParametersGroup = {
  type: string;
  data: ItemCheckParameter[];
};

export type ItemCheck = {
  idCheck: number;
  isActiveCheck: number;
  isDeleteCheck: number;
  expiresIn: number;
  isRepeat: number;
  idRequest: number;
  idRequestReference?: number;
  statusRequest: number;
  idUser: number;
  idInstructor: number;
  check: string;
  category: string;
  displayName: string;
  email?: string;
  phone1?: string;
  instructor: string;
  dateAssigned: string;
  dateExpires: string;
  dateResult: string;
  dateSubmited: string;
  resultItem: string;
  chequeo: string;
  curso: string;
  habilitacion: string;
  observaciones: string;
  requisitosCondicion: string;
  requisitosFamiliarizacion: string;
  obsPilot: string;
  result: string;
  cancelReason: string;
  idCheckParameters: number[];
  jsonResults: any[];
  jsonParams: any[];
  obs: string;
  equipmentCheck: string;
  instructorCheck: string;
  icon: string;
  label: string;
  value: string;
  checks?: any[];
  idBooking?: number;
  jsonBooking?: any;

}


/* ITEM FLIGHTS */

export type ItemNotification = {
  type: string;
  count: number;
  notification: string;
  href: string;
  title: string;
  color: string;
  date: string;
  time: string;
  day: string;
  idMessage: number;
  loading: boolean;
}

export type FlightCost = {
  UF: number;
  flightCost: number;
  flightCostStr: number;
  flightTime: number;
  flightTotal: number;
  flightTotalStr: string;
  hourCost: number;
  status: number;
  totalVuelo: number;
  towCost: number;
  towCostStr: string;
  tpoVuelo: number;

}
export type ItemFlightType = {
  label: string;
  value: string;
  idFlightType: number;
  showOnFlightLog: number;
  flightType: string;
  bookingTypeBadge: string;
}

export type ItemAltitudes = {
  label: string;
  value: string;
  altitude: number
}

export type ItemFlight = {
  idFlight: number;
  idCategory?: number;
  idEquipment: number;
  idFlightType: number;
  idGroupType?: number;
  idMovement?: number;
  idTowingTo?: number;
  idUserPilot: number;
  isClosed?: number;
  isClub?: number;
  idUserInstructor?: number;
  isInvoiced?: number;
  isInvoice?: number;
  isTowPlane?: number;
  delta?: number;
  cost?: number;
  costReal?: number;
  idUserCost?: number;
  altitude?: number;
  departureDate?: string;
  departureTime?: string;
  departureDateTime?: string;
  arrivalDateTime?: string;
  flightType?: string;
  groupType?: string;
  groupTypeMaster?: string;
  groupTypeMasterCode?: string;
  category?: string;
  arrivalDate?: string;
  arrivalTime?: string;
  registration?: string;
  make?: string;
  model?: string;
  userPilot?: string;
  userInstructor?: string;
  equipmentType?: string;
  registrationTow?: string;
  userTow?: string;
  arrivalTimeTow?: string;
  idUserTow?: number;
  idEquipmentTow?: number;
  obs?: string;
  modelTow?: string;
  bookingTypeBadge?: string;
  index?: number;
  timeCount?: string;
  tacStart?: number;
  tacEnd?: number;
  loading?: boolean;
  oCost?: any;
  jsonSoftMantto?: any;
  softmantto?: boolean
  ciclesLanding?: number;
}

//BANKS

export type BankItems = {
  idMovementBank: number,
  monto: number,
  id: string,
  fechaMovimiento: string,
  dateCreated: string,
  tipoMovimiento: string,
  glosa: string,
  cuenta: string,
  RUT: string,
  remitente: string,
  banco: string,
  idMovement: number,
  idUser: number,
  ACK: number,
  displayName: string,
  userStatus: string,
  canConcileBank: string,
  status: string,
  jsonBank: any,
};


export type ItemEquipment = {
  idEquipment: number,
  equipment: string,
  image: string,
  isBookCapable: number,
  idGroupType: number,
  isClub: number,
  idModel: number,
  isActiveEquipment: number,
  isDeleteEquipment: number,
  isMant: number,
  isInvoice: number,
  isOutOfFlight: number,
  registration: string
  groupTypeMasterCode: string
  groupType: string
  make: string
  model: string
  category: string
  idCategory: number
  hourCost: number
  hourCostFree: number
  thresholdAfter: number
  thresholdBefore: number
  value: string,
  label: string,
  description: string,
  tags: [],
  labelTag: string,
  timeCount: string,
  outOfFlightStart: string,
  outOfFlightEnd: string,
  idFlarm: string,
  idSpider: string,
  jsonSII: any,
  jsonOwners: number[]
  jsonAltitudes: any[]
  docs: any[];
  jsonEquipmentSoftMantto: any;
  idEquipmentSoftMantto: number;
  jsonTowingTimes: any;
  syncSoftMantto?: number;
  maxPAX?: number;
  obsCMA?: string;
  flarm24?: string;
};

export const weekDays = [
  { label: 'Lunes', value: '1' },
  { label: 'Martes', value: '2' },
  { label: 'Miércoles', value: '3' },
  { label: 'Jueves', value: '4' },
  { label: 'Viernes', value: '5' },
  { label: 'Sábado', value: '6' },
  { label: 'Domingo', value: '7' },
  { label: 'Feriados', value: '0' },
]

export type ItemBooking = {
  idBooking: number;
  idBookingType: number;
  idEquipment: number;
  idUser: number;
  idUserPilot: number;
  idUserInstructor: number;
  idGroupType?: number;
  idInstructor?: number;
  thresholdBefore?: number;
  thresholdAfter?: number;
  displayName: string;
  obsBooking: string;
  registration: string;
  equipment: string;
  bookingType: string;
  timeStart: string;
  timeEnd: string;
  dateStart: string;
  dateEnd: string;
  dateSubmited: string;
  timeSubmited: string;
  obs: string;
  towType: 'NONE' | 'MOUNTAIN' | 'LOCAL' | 'BALLAST';
  instructor: string;
  groupType: string;
  bookingTypeBadge: string;
  minBookHour: number;
  maxBookHour: number;
  canDelete: number;
  maxPAX: number;
  idRequest: number;
  pax: 0;
  towingMinutes?: 0;
  equipmentType?: string;
  groupTypeMasterCode?: string;
};

export type ItemNews = {
  idNews: number;
  idCategory: number;
  isActiveNews: number;
  category: string;
  datePublish: string;
  datePublishLong: string;
  dateCreated: string;
  timePublish: string;
  timeCreated: string;
  title: string;
  subTitle: string;
  html: string;
  images?: string[];
};

export interface OptionDefinition {
  label: string;
  value: string;
}


export type ItemShiftFlight = {
  idShift: number;
  sequence: number;
  idFlight: number;
  idEquipment: number;
  idFlightType: number;
  idUserPilot: number;
  idUserInstructor: number;
  altitude: number;
  idEquipmentTow: number;
  idUserTow: number;
  departureDate: string;
  arrivalDate: string;
  arrivalDateTow: string;
  obs: string;
  isClosed: number;
  isDelete: number;

  registration?: string;
  registrationTow?: string;
  userPilot?: string;
  userInstructor?: string;
  userTow?: string;
  flightType?: string;
  flightTypeBadge?: string;

}
export type ItemShift2 = {
  idShift: number;
  isSelling: number;
  dateShift: string;
  isToday: number;
  isPast: number;
  isFuture: number;
  jsonExchange?: any;
  AM?: any;
  PM?: any;
  DIR?: any;
  isReplacementOpen?: number;

}
export type ItemShift = {
  idShift: number;
  idUserDirector: number;
  idUserDirectorOld: number;
  idUserTowing1: number;
  idUserTowingOld1: number;
  idUserTowing2: number;
  idUserTowingOld2: number;
  idMercenaryUser: number;
  idUserMercenary?: number;
  isSelling: number;
  dateShift: string;
  userDirector: string;
  userDirectorOld: string;
  userTow1: string;
  userTow1Old: string;
  userTow2: string;
  userTow2Old: string;
  isTodayOrPast: boolean;
  label: string;
  value: string;
  keyw: string;
  idMercenaryUsers: string;
  jsonMercenaries: any[];
  dateEndSelling: string;
  dateStartSelling: string;
  timeEndSelling: string;
  timeStartSelling: string;
  jsonExchange?: any;
  jsonExchangeAM?: any;
  jsonExchangePM?: any;
  isToday?: boolean;
  isPast: number;
  isFuture: number;
  userMercenary?: string;
  user?: string;
  shift?: string;
  phone1?: string;
  email?: string;

};

export type ItemDirector = {
  idShift: number;
  isSelling: number;
  dateShift: string;
  user: string;
  idUser: number;
  shift: string;
  label: string;
  value: string;
  jsonExchange?: any;
};

export type ItemPollQuestion = {
  idQuestion: number;
  idPoll: number;
  question: string;
  description: string;
  questionType: string;
  results?: any[];
  votes?: number;
  answers?: any[];
  answer: {
    idAnswer: number;
    answer: any;
    visibilityAnswer: number;
  }
  questionParameters: {
    options: { label: string; value: string }[];
    optionsRequired: number;
    required: number;
    minLength: number;
    maxLength: number;
  };
  questionOrder: number;
  index?: number;
  visibilityQuestion: number;
  expanded: boolean;
}

export type ItemPollAnswer = {
  idAnswer: number;
  idQuestion: number;
  idUser: number;
  answer: string;
  dateAnswer: string;
  dateUpdate: string;
  visibilityAnswer: number;
}

export type ItemPoll = {
  idPoll: number;
  totalUsers: number;
  totalEnabled?: number;
  maxAllowance: number;
  publicResults: number;
  publicAnswers: number;
  liveResults?: number;
  isActivePoll: number;
  hasStarted: number;
  hasEnded: number;
  hasOpen: number;
  idUserTypes: number[];
  idUserGroups: number[];
  results: any[];
  answers: {
    [x: string]: number; idQuestion: number, answer: any, idUser: number
  }[];
  questions: ItemPollQuestion[];
  poll: string;
  description: string;
  dateStart: string;
  timeStart: string;
  dateEnd: string;
  timeEnd: string;
  dateOpen: string;
  timeOpen: string;
  dateClose: string;
  timeClose: string;
  emailSent: string;
  visibility: number;
  showOnHome?: number;
  pollType?: string;
  userCanAnswer?: number;
  userCanDeleteRegistration?: number;
  isCompleteUser?: number;
}

export type ItemMailTemplateFile = {
  idMailTemplateFile: number;
  idMailTemplate: number;
  fileName: string;
  fileContent: string;
  fileSize: number;
  hashMailTemplateFile: string;
  loaded: boolean;
  deleted: boolean;
}

export type ItemMailTemplate = {
  idMailTemplate: number;
  status: number;
  subject: string;
  html?: string;
  replyTo?: string;
  dateCreated?: string;
  dateModified?: string;
  dateSend?: string;
  timeCreated?: string;
  timeModified?: string;
  timeSend?: string;
  copy?: string;
  cc?: string[];
  idGroups: number[];
  idStatuses: number[];
  idCharges: number[];
  idChecks: number[];
  idUserTypes: number[];
  files?: ItemMailTemplateFile[];
  intersection?: number;
}


export interface ItemDocument {
  id: number;
  idFolder: number;
  idFile: number;
  idParent: number;
  isPublic: number;
  objects: number;
  name: string;
  content: string;
  type: string;
  iconName: string;
  extension: string;
  fileSize: string;
  dateCreated: string;
  timeCreated: string;
  idUser?: number;
  nestedItems?: ItemDocument[];
}

export interface ItemFile {
  idFile: number;
  ordenFile?: number;
  isActiveFile?: number;
  isDeleteFile?: number;
  fileName: string;
  file?: string;
  fileType?: string;
  idFolder: number;
  fileSize?: number;
  datePublish?: string;
  isPublicFile?: number;
  idUser?: number;
  isAproved?: number;
}
export interface ItemFolder {
  idFolder: number;
  ordenFolder?: number;
  isReadFolder?: number;
  isDeleteFolder?: number;
  isActiveFolder?: number;
  isPublicFolder: number;
  filesInFolder?: number;
  foldersInFolder?: number;
  idParentFolder: number;
  folder: string;
  isAproved?: number;
  taregtIdFolder?: number;
}

export interface ItemDTEIdDoc {
  tipoDTE?: number;
  Folio?: 0;
  FchEmis?: string;
  TpoTranCompra?: number;
  TpoTranVenta?: number;
  FmaPago?: number;
}
export interface ItemDTEDetalle {
  NroLinDet?: number;
  NmbItem?: string;
  DscItem?: string;
  QtyItem?: number;
  PrcItem?: number;
  MontoItem?: number;
}
export interface ItemDTETotales {
  MntNeto?: number;
  IVA?: number;
  MntTotal?: number;
}
export interface ItemDTEReceptor {
  RUTRecep?: string;
  RznSocRecep?: string;
  GiroRecep?: string;
  DirRecep?: string;
  CmnaRecep?: string;
}
export interface ItemDTEEmisor {
  RUTEmisor?: string;
  RznSoc?: string;
  GiroEmis?: string;
  Acteco?: number;
  DirOrigen?: string;
  CmnaOrigen?: string;
}

export interface ItemDTEEncabezado {
  IdDoc?: ItemDTEIdDoc;
  Emisor?: ItemDTEEmisor;
  Receptor?: ItemDTEReceptor;
  Totales?: ItemDTETotales;
}
export interface ItemDTE {
  Encabezado?: ItemDTEEncabezado;
  Detalle?: ItemDTEDetalle[];

}
export interface ItemHaulmer {
  dte?: ItemDTE;
  response?: string[];
}

export interface ItemFuelMesure {
  idMovementTank: number;
  liters?: number;
  receipt?: number;
  dateMeasure?: string;
  tank?: string;
  measureType?: string;
  jsonMeasure?: any;
  obs?: string;
  load?: number;
}

export type ItemACK = {
  idACK: number;
  isActiveACK: number;
  ACKTitle: string;
  ACK: string;
  fechaACK: string;
  isReadACK: number[];
  isSignACK: number[];
  idGroups: number[];
  idUserTypes: number[];
  loading?: boolean;
  isSigned?: number;
};

export const colorsArray = ["#688ae8", "#c33d69", "#2ea597", "#8456ce", "#e07941", "#3759ce", "#962249", "#096f64", "#6237a7", "#a84401"]
//"#ed1622", "#e6bde5", "#f36493", "#9caad8", "#bbebf0", "#d0d962", "#ff9528", "#a58b84", "#7a59bc", "#2b383e", "#4a6b78", "#88c241", "#d6d9da", "#b2e1da", "#43a047", "#1e88e5", "#fbc02d", "#757575"


export const btnDanger = {
  background: {
    active: 'light-dark(#ff0f0f, #ff0f0f)',
    default: 'light-dark(#ff0f0f, #ff0f0f)',
    hover: 'light-dark(#d10000, #d10000)',
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  color: {
    active: 'light-dark(white, white)',
    default: 'light-dark(white, white)',
    hover: 'light-dark(white, white)',
    disabled: 'light-dark(#8C8C94, #8C8C94)',
  },
  borderColor: {
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  borderWidth: '0px',
  paddingBlock: '4px',
  paddingInline: '16px',
}
export const btnSuccess = {
  background: {
    active: 'light-dark(#00802f, #00802f)',
    default: 'light-dark(#00802f, #00802f)',
    hover: 'light-dark(#006927, #006927)',
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  color: {
    active: 'light-dark(white, white)',
    default: 'light-dark(white, white)',
    hover: 'light-dark(white, white)',
    disabled: 'light-dark(#8C8C94, #8C8C94)',
  },
  borderColor: {
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  borderWidth: '0px',
  paddingBlock: '4px',
  paddingInline: '16px',
}

export const btnWarn = {
  background: {
    active: 'light-dark(#f90, #f90)',
    default: 'light-dark(#f90, #f90)',
    hover: 'light-dark(#ec7211, #ec7211)',
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  color: {
    active: 'light-dark(black, black)',
    default: 'light-dark(black, black)',
    hover: 'light-dark(black, black)',
    disabled: 'light-dark(#8C8C94, #8C8C94)',
  },
  borderColor: {
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  borderWidth: '0px',
  paddingBlock: '4px',
  paddingInline: '16px',
}

export const btnIcon = {
  borderColor: {
    active: 'light-dark(#006ce0, #75cfff)',
    default: 'light-dark(#006ce0, #42b4ff)',
    hover: 'light-dark(#002B66, #75cfff)',
    disabled: 'light-dark(#EBEBF0, #EBEBF0)',
  },
  background: {
    active: 'light-dark(white, #333843)',
    default: 'light-dark(white, #161d26)',
    hover: 'light-dark(#F0FBFF, #161d26)',
    disabled: 'light-dark(#8C8C94, #8C8C94)',
  },
  color: {
    active: 'light-dark(white, #75cfff)',
    default: 'light-dark(#006ce0, #42b4ff)',
    hover: 'light-dark(#002B66, #75cfff)',
    disabled: 'light-dark(#8C8C94, #8C8C94)',
  },
  borderWidth: '2px',
  paddingBlock: '2px',
  paddingInline: '6px',
}

export const btnIconForm = {
  background: {
    active: 'light-dark(#006ce0, #42b4ff)',
    default: 'light-dark(#006ce0, #42b4ff)',
    hover: 'light-dark(#002B66, #75cfff)',
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  color: {
    active: 'light-dark(white, #0f141a)',
    default: 'light-dark(white, #0f141a)',
    hover: 'light-dark(#F0FBFF, #002b66)',
    disabled: 'light-dark(#8C8C94, #8C8C94)',
  },
  borderColor: {
    active: 'light-dark(white, #42b4ff)',
    default: 'light-dark(white, #42b4ff)',
    hover: 'light-dark(#F0FBFF, #75cfff)',
    disabled: 'light-dark(#EBEBF0, #232b37)',
  },
  top: 0,
  //height: '33px',
  borderRadius: '10px',
  borderWidth: '0px',
  paddingBlock: '2px',
  paddingInline: '6px',
}


export const pilotTypes = [
  { value: 'PILOT', label: 'Piloto', id: 'PILOT', text: 'Piloto' },
  { value: 'INSTRUCTOR', label: 'Instructor', id: 'INSTRUCTOR', text: 'Instructor' },
  { value: 'BOTH', label: 'Ambos', id: 'BOTH', text: 'Ambos' },
]
export const btnIconFormOutline = {
  borderColor: {
    active: 'light-dark(#006ce0, #006ce0)',
    default: 'light-dark(#006ce0, #006ce0)',
    hover: 'light(#002B66, #002B66)',
    disabled: 'light-dark(#EBEBF0, #EBEBF0)',
  },
  background: {
    active: 'light-dark(white, white)',
    default: 'light-dark(white, white)',
    hover: 'light-dark(#F0FBFF, #F0FBFF)',
    disabled: 'light-dark(#EBEBF0, #EBEBF0)',
  },
  color: {
    active: 'light-dark(white, white)',
    default: 'light-dark(#006ce0, #006ce0)',
    hover: 'light-dark(#002B66, #002B66)',
    disabled: 'light-dark(#8C8C94, #8C8C94)',
  },
  height: '24px!important',
  borderRadius: '10px',
  borderWidth: '2px',
  paddingBlock: '2px',
  paddingInline: '6px',
}